import { defaultMemoize } from 'reselect';
import { appConstants } from '../constants/appConstants';

export function getNewEndPoint(endPoint){
  if(endPoint){
    switch(endPoint){
      case 'overview':
        return 'overview';
      case 'navigateToBankAccount':
        return 'bankaccounts';
      case 'order':
        return 'orders';
      case 'myAccount':
        return 'pairingcodes';
      case 'mobiledevices':
        return 'pairingcodes';
      case 'pairingcodes':
        return 'pairingcodes';
    }
  }
  return endPoint;
}

export const filterSideNav = (submenu, nav, basePath, isNavSelect) => (
  submenu.filter((menu, index) => {
    if(menu.submenu){
      filterSideNav(menu.submenu, nav);
    }
    const subMenuLink = menu.link.split('/');
    const len = subMenuLink.length;
    const endPoint = subMenuLink[len - 1];
    let tempEndPoint = endPoint.split('.seam');
    tempEndPoint = getNewEndPoint(tempEndPoint[0]);
    let isMatched = false;
    if(tempEndPoint  === 'claimCode' || tempEndPoint === 'claimacode'){
      submenu.splice(index, 1);
    }else{
      isMatched = nav.indexOf(tempEndPoint) > -1;
      menu['replace'] = isNavSelect ? menu['replace'] : !isMatched;
      menu['link'] = isMatched ? (basePath + '/' + tempEndPoint) : menu['link'];
      menu['selected'] = isNavSelect ? isMatched : false;

    }
  })
  
);
  
export const selectCompiledSideNav = defaultMemoize((activity = [], basePath = '') => {
  //const sideNavData = activity.find(nav => (CommonActions.replaceAllSpecialChars(nav.title).toLowerCase() === 'myaccount' && nav));
  const sideNavData = activity.find(nav => (nav && nav.link.includes(appConstants.ROUTE_OVERVIEW)));
  const newNavs = ['pairingcodes','bankaccounts', 'overview', 'orders'];
  if(sideNavData !== undefined){
    filterSideNav(sideNavData.submenu, newNavs, basePath);
  }
  return sideNavData;
});
  
export const selectCompiledCartLink = defaultMemoize(({
  banks = [],
  cart = { link: '#' },
  redeem = []
} = {}) => {
  const bankFilter = banks.filter((bank) => bank.isPointsBank && bank.points > 0 && bank.link);
  if (cart.link !== '#' && redeem) {
    return cart.link;
  } else if (bankFilter.length > 0) {
    return bankFilter.slice(-1)[0].link;
  }
  return cart.link;
});
  
  // Layouts selectors and transforms
export const formatPoints = defaultMemoize((points = '0') => parseInt(points, 10).toLocaleString().replace('.00', ''));
  
export const getFriendlyDate = defaultMemoize((awardExpiresDate, currentDate = new Date()) => {
  if (awardExpiresDate.getFullYear() - currentDate.getFullYear() > 10 ||
      isNaN(awardExpiresDate.getFullYear())) {
    return 'N/A';
  }
  return awardExpiresDate.toDateString();
});
  
export const generateBankPoints = defaultMemoize((
  { id = '', isAccessCodeBank = false, isPointsBank = false, points = 0 },
  awards = []
) => {
  if (isPointsBank && points) {
    return points;
  } else if (isAccessCodeBank) {
    return awards.filter((award) => (award.bank ? id === award.bank.id : true)).length.toString();
  }
  return '0';
});
  
export const selectCompiledCatalogPoints = defaultMemoize(({
  banks = [
    {
      isPointsBank: false,
      isCurrentBank: false,
      points: 0
    }
  ],
  awards = []
} = {}) => {
  // let pointsCount = 0;
  // pointsCount = awards.length > 0 ? awards.length : pointsCount;
  // let bankFilter = banks.filter((bank) => bank.isPointsBank && bank.points > 0);
  // pointsCount = bankFilter.length > 0
  //   ? bankFilter.reduce((acc, bank) => `${acc} ${formatPoints(bank.points)}`, '')
  //   : formatPoints(pointsCount);
  // bankFilter = banks.filter((bank) => bank.isCurrentBank && bank.isPointsBank && bank.points > 0);
  // pointsCount = bankFilter.length > 0
  //   ? bankFilter.reduce((acc, bank) => `${acc} ${formatPoints(bank.points)}`, '')
  //   : pointsCount;
  // return pointsCount;
  let pointsCount = 0;
  pointsCount = awards.length > 0 ? awards.length : pointsCount;
  // let bankFilter = banks.filter((bank) => bank.isPointsBank && bank.points > 0);
  // pointsCount = bankFilter.length > 0
  //   ? bankFilter.reduce((acc, bank) => `${acc} ${formatPoints(bank.points)}`, '')
  //   : formatPoints(pointsCount);
  const bankFilter = banks.filter((bank) => bank.isCurrentBank && bank.points > 0);
  pointsCount = bankFilter.length > 0
    ? bankFilter.reduce((acc, bank) => `${acc} ${formatPoints(bank.points)}`, '')
    : formatPoints(pointsCount);
  return pointsCount;
});
  
export const selectCompiledCatalogLink = defaultMemoize(({
  banks = [
    {
      isPointsBank: false,
      isCurrentBank: false,
      points: 0,
      link: ''
    }
  ],
  redeem = {
    link: ''
  },
  catalogs = [],
  awards = []
} = {}) => {
  let catalogLink = '#';
  catalogLink = awards.reduce((acc, awardListItem) => {
    if (!!awardListItem.link && acc === '#') return awardListItem.link;
    else return acc;
  }, catalogLink);
  let bankFilter = banks.filter(
    (bank) => bank.points > 0 && bank.link && bank.link.indexOf('viewAwards') === -1
  );
  catalogLink = bankFilter.length > 0 ? bankFilter[0].link : catalogLink;
  catalogLink = catalogs.length > 0 ? catalogs[0].link : catalogLink;
  catalogLink = redeem.link ? redeem.link : catalogLink;
  bankFilter = banks.filter((bank) => bank.isPointsBank && bank.points > 0);
  catalogLink = bankFilter.length > 0 ? bankFilter.slice(-1)[0].link : catalogLink;
  bankFilter = banks.filter((bank) => bank.isCurrentBank);
  catalogLink = bankFilter.length > 0 ? bankFilter.slice(-1)[0].link : catalogLink;
  return (catalogLink.replace(/cart/i, ''));
});
  
export const selectTransformedBanks = defaultMemoize(({
  banks = [],
  awards = []
} = {}) => banks.map((bank) =>
  Object.assign({}, bank, {
    link: bank.link,
    points: formatPoints(generateBankPoints(bank, awards))
  })
));
  
export const selectTransformedAwards = defaultMemoize(({
  awards = []
} = {}) => awards.map((award) =>
  Object.assign({}, award, {
    link: award.link,
    expires: getFriendlyDate(new Date(award.expires))
  })
));
  
export const selectTransformedCatalogs = defaultMemoize(({
  catalogs = []
} = {}) => catalogs.map((catalog) =>
  Object.assign({}, catalog, {
    link: catalog.link
  })
));
  
export const convertToColorCode = defaultMemoize((colorCode = '') => {
  if (colorCode.indexOf('rgb') === -1 && colorCode.indexOf('#') === -1) {
    return `#${colorCode}`;
  }
  return colorCode;
});
  
export const selectCompiledPrimaryColor = ({ theme: { primaryHexColor = '' } = {} } = {}) =>
  convertToColorCode(primaryHexColor);
  
export const selectCompiledSecondaryColor = ({ theme: { secondaryHexColor = '' } = {} } = {}) =>
  convertToColorCode(secondaryHexColor);
  
export const selectCompiledNeutralColor = ({ theme: { neutralHexColor = '' } = {} } = {}) =>
  convertToColorCode(neutralHexColor);

export const selectFooterLinks = defaultMemoize(({ 
  footer = [] 
} = {}) =>  {
  const footerLinks = [];
  footer.filter(
    (footerItem) => {
      if(footerItem.link || footerItem.content || footerItem.form){
        footerLinks.push(footerItem);
      }
    }
  );
  return footerLinks;
});

export const selectLogoutLink = defaultMemoize(({ logout = {} } = {}) => logout);

export const selectAvatarDetails = defaultMemoize(({ avatar = {} } = {}) => avatar);

export const selectRedeemPrograms = defaultMemoize(({ redeemedPrograms = [] } = []) => redeemedPrograms);
